
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5 1C8.354 1 5 4.443 5 8.7 5 14.475 12.5 23 12.5 23S20 14.475 20 8.7C20 4.443 16.646 1 12.5 1zm0 10.45c-1.479 0-2.679-1.232-2.679-2.75s1.2-2.75 2.679-2.75c1.479 0 2.679 1.232 2.679 2.75s-1.2 2.75-2.679 2.75z","id":"🎨-Color","fill":"#000"}})])
          )
        }
      }
    